/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var PropTypes = require("prop-types");
var React = require("react");
var OutsideClick_1 = require("./util/OutsideClick");
var Panel_1 = require("./Panel");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./ProfileDropdown.css'); }
var Icon_1 = require("./Icon");
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("profileDropdown");
var ProfileDropdown = /** @class */ (function (_super) {
    tslib_1.__extends(ProfileDropdown, _super);
    function ProfileDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            active: false
        };
        _this.handleIconClick = _this.handleIconClick.bind(_this);
        _this.handleOutsideClick = _this.handleOutsideClick.bind(_this);
        return _this;
    }
    ProfileDropdown.prototype.handleIconClick = function (e) {
        e.preventDefault();
        this.setState({
            active: !this.state.active
        });
    };
    ProfileDropdown.prototype.handleOutsideClick = function () {
        this.setState({ active: false });
    };
    ProfileDropdown.prototype.render = function () {
        var options = this.props.options;
        var active = this.state.active;
        return (React.createElement(OutsideClick_1.OutsideClick, { onOutsideClick: this.handleOutsideClick },
            React.createElement("div", null,
                React.createElement("button", { className: moduleClassName("trigger"), onClick: this.handleIconClick },
                    React.createElement(Icon_1.Icon, { type: "profile", size: 1.25, color: "blue-tint-90" })),
                active && (React.createElement(Panel_1.Panel, { className: moduleClassName() },
                    React.createElement("div", { className: "arrow_box_ne" },
                        React.createElement("ul", null, options.map(function (option) { return (React.createElement("li", { key: option.name, className: moduleClassName("listItem") },
                            React.createElement("a", { onClick: option.onClick }, option.label))); }))))))));
    };
    ProfileDropdown.propTypes = {
        options: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.string.isRequired,
            onClick: PropTypes.func.isRequired,
            label: PropTypes.string.isRequired
        }))
    };
    return ProfileDropdown;
}(React.Component));
exports.ProfileDropdown = ProfileDropdown;